import styled from 'styled-components';
import { BasketScrappageDetailsStyled } from '../BasketScrappageDetailsStyled';
import { rem } from 'polished';

export const BasketScrappageDetailsOV = styled(BasketScrappageDetailsStyled)`
    
`;
